import React, { useEffect, useState } from "react";
import Loader from "./Loader";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { blobURL } from "common/StringUtils";
import { useTranslation } from "react-i18next";

const ApprovalNotifyPage = () => {
  const [loading, setLoading] = useState(false);
  const [isApproved, setIsApproved] = useState();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { t } = useTranslation();

  // Access individual parameters
  const invoiceId = searchParams.get("data");
  const userId = searchParams.get("createData");
  const approve = JSON.parse(searchParams.get("Approve"));
  const encodedInvoiceId = encodeURIComponent(invoiceId);
  const encodeduserId = encodeURIComponent(userId);

  const lang = searchParams.get("lang");
  const [showError, setShowError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const URL = `/invoice/approval-invoice?data=${encodedInvoiceId}&createData=${encodeduserId}&approve=${approve}&lang=${lang}`;
        const result = await axios.put(URL);
        if (result.status === 200) {
          setLoading(false);
          if (approve === true) {
            setIsApproved(true);
          } else {
            setIsApproved(false);
          }
        }
      } catch (error) {
        if (error?.response) {
          setShowError(t(error?.response?.data?.message));
        }
        setLoading(false);
        setIsApproved();
      }
    };

    fetchData();
  }, [approve, encodedInvoiceId, encodeduserId, lang]);

  const mainLogoNew = `${blobURL}/fakt-logo.png`;

  return (
    <div>
      <>
        {loading ? (
          <Loader />
        ) : (
          <>
            {" "}
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
              <a
                className="navbar-brand"
                href="#"
                style={{ cursor: "default" }}
              >
                <img
                  className="mr-md-4 ml-4 mr-2 logo  img-fluid"
                  src={mainLogoNew}
                  alt="site-logo"
                  height={100}
                  width={100}
                  loading="lazy"
                  // onClick={() => navigate("/")}
                />
              </a>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </nav>
            <div className="bg_clr">
              <div className="row justify-content-center w-100">
                <div className="col-lg-4">
                  <div className="unsubscribe-container">
                    <div className="unsubscribe-success">
                      <div className="icon-container">
                        <i className="fas fa-check-circle success-icon"></i>
                      </div>
                      {isApproved ? (
                        <div className="text-center">
                          <h1 className="success-heading">
                            {t("Approved successfully")}
                          </h1>
                          <p className="success-message">
                            {t("Thank you! Your preliminary invoice has been approved. Our freelancer will soon send you a final invoice.")}
                          </p>
                        </div>
                      ) : isApproved === false ? (
                        <div className="text-center">
                          <h1 className="success-heading">
                            {t("Denied successfully!")}
                          </h1>
                          <p className="success-message">
                            {t("Your invoice has been refused.")}
                          </p>
                        </div>
                      ) : (
                        <p className="success-message" style={{ color: "red" }}>
                          {t(showError)}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    </div>
  );
};

export default ApprovalNotifyPage;
